import { render, staticRenderFns } from "./SeatV2.vue?vue&type=template&id=6b8ccdcb&scoped=true&"
import script from "./SeatV2.vue?vue&type=script&lang=js&"
export * from "./SeatV2.vue?vue&type=script&lang=js&"
import style0 from "./SeatV2.vue?vue&type=style&index=0&id=6b8ccdcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ccdcb",
  null
  
)

export default component.exports